import { create } from 'zustand';

type State = {
  tokenexIframe?: Record<string, any>;
  cardNumber: string | null;
};

type Action = {
  setTokenexIframe: (val: State['tokenexIframe']) => void;
  getTokenexIframe: () => State['tokenexIframe'];
  setCardNumber: (val: State['cardNumber']) => void;
  getCardNumber: () => State['cardNumber'];
};

/**
 * Zustand store to hold detected card reader data.
 * Includes the iFrame reference for feeding the data into the correct iFrame.
 */
export const useCardReaderDataStore = create<State & Action>()((set, get) => ({
  tokenexIframe: {} as State['tokenexIframe'],
  setTokenexIframe: (tokenexIframe: State['tokenexIframe']) =>
    set({ tokenexIframe }),
  getTokenexIframe: () => get().tokenexIframe,

  cardNumber: null,
  setCardNumber: (cardNumber: State['cardNumber']) => set({ cardNumber }),
  getCardNumber: () => get().cardNumber,
}));
